import React, { useEffect, useState } from "react";
import ConsumoController from "../../controllers/ConsumoController";
import { UseContextApp } from "../../Global/Context/appContext";
import Spinner from "../../components/Loading/loadingSpinner/Spinner";
import { Link, useLocation } from "react-router-dom";
import BreadCrumbsGeneric from "../../components/Nav/BreadCrumbsGeneric";
import { colors } from "../../propsType/Colors";
function ViewBills() {
  const { saldo } = ConsumoController();
  const [{ user }] = UseContextApp();
  const [dataBills, setDataBills] = useState([""]);
  const location = useLocation();
  const pathName = location.pathname;
  const [loading, setLoading] = useState(false);


  //Funcion que obtiene el numero de cuenta
  const getSaldo = async () => {
    setLoading(true);
    const res = await saldo(user);
   
    if (res) {
      setDataBills(res);
      setLoading(false);
    } else {
    }
  };

  useEffect(() => {
    getSaldo();
  }, []);

  return (
    <div className=" bg-[#f3f4f6] ">
      <div className="flex max-w-7xl mx-auto  pt-6 justify-center min-h-screen">
        {loading ? (
          <>
            <div className="w-full h-screen flex justify-center items-center ">
              <Spinner title={"Espere..."} />
            </div>
          </>
        ) : (
          <>
            <div className="flex lg:w-full gap-5 px-4 overflow-auto flex-col">
              <BreadCrumbsGeneric locations={pathName} />
              <div className="bg-white rounded-[10px] py-5 lg:py-0 border-b border-gray-200 lg:px-0 px-6">
                <div className=" py-6 px-6 sm:px-6">
                  <div className="py-2 text-2xl font-medium ">Facturas</div>
                  <div className=" text-lg font-regular ">
                    Selecciona el número de cuenta que deseas consultar
                  </div>
                </div>
                <div className="!m-0 overflow-x-auto sm:-mx-6 lg:-mx-8 bg-white rounded-[10px] gap-5 shadow-lg  mt-5 ">
                  {dataBills?.lCuenta?.length > 0 ? (
                    <>
                      <div className="bg-white shadow overflow-hidden sm:rounded-md">
                        <ul role="list" className="divide-y divide-gray-200">
                          <div className=" hidden px-4 py-2 md:grid gap-4 lg:grid-cols-4 sm:px-6 border-b border-gray-200">
                            <div
                              className={`font-medium text-center  text-[14px] text-[${colors.darkBlue}]`}
                            >
                              Número de cuenta
                            </div>
                            <div
                              className={`font-medium text-center  text-[14px] text-[${colors.darkBlue}]`}
                            >
                              Servicios
                            </div>
                            <div
                              className={`font-medium text-center  text-[14px] text-[${colors.darkBlue}]`}
                            >
                              Titular
                            </div>
                            <div
                              className={`font-medium  text-center text-[14px] text-[${colors.darkBlue}]`}
                            ></div>
                          </div>
                          {dataBills?.lCuenta.map((cuenta) => (
                            <Link
                              state={{ data: cuenta }}
                              to={"/cuenta/pagos/estado-de-cuenta"}
                              className="group"
                            >
                              <li key={cuenta.id}>
                                <div className="px-4 py-4 grid gap-4 lg:grid-cols-4 sm:px-6 group-hover:bg-gray-50">
                                  <div
                                    className={`text-sm text-start justify-center flex items-end font-medium text-[${colors.lightBlue}]`}
                                  >
                                    {cuenta.nroCuenta}
                                  </div>
                                  <div className="text-sm text-gray-500 text-center justify-center flex items-end font-medium   ">
                                    {cuenta.servicios.length > 20 ? (
                                      <>
                                        <div
                                          className="button cursor-pointer decoration-txt"
                                          data-tooltip={cuenta.servicios}
                                        >
                                          {cuenta.servicios.substr(0, 20)}...
                                        </div>
                                      </>
                                    ) : (
                                      <>{cuenta.servicios}</>
                                    )}
                                  </div>
                                  <div>
                                    <div className="flex items-center gap-2 flex-col text-sm text-gray-500">
                                      <div className="font-medium text-[14px] md:hidden block  ">
                                        Titular
                                      </div>
                                      <div>{user?.datos?.nombreApellido}</div>
                                    </div>
                                  </div>
                                  {/*    Se manda el numero de cuenta por paramtros para ver los estado de cuenta */}
                                  <div className="flex items-end w-full justify-around ">
                                    <Link
                                      state={{ data: cuenta }}
                                      to={"/cuenta/pagos/estado-de-cuenta"}
                                      className={`font-medium text-[${colors.lightBlue}]`}
                                    >
                                      Ver Estado de Cuenta
                                    </Link>
                                  </div>
                                </div>
                              </li>
                            </Link>
                          ))}
                        </ul>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="h-[20vh] flex justify-center items-center text-[1.3rem] font-semibold  ">
                        No posees facturas.
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ViewBills;
